import React from 'react';
import PropTypes from 'prop-types';
import LoaderIcon from './LoaderIcon';
import AddressDisplay from '../components/AddressDisplay';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Divider from '@mui/material/Divider';

const AddressListWidget = (props) => {
   if (props.loading)
      return (<LoaderIcon />);

   const handleAddressDelete = (position) => {
      props.onDeleteAddress(position);
   }

   return (
      <List dense={true}>
         {props.savedAddresses.firstSavedAddress ? <ListItem
            secondaryAction={
               <IconButton edge="end" aria-label="delete" onClick={() => handleAddressDelete(1)}>
                  <DeleteIcon />
               </IconButton>
            }
         >
            <ListItemText
               primary={<AddressDisplay address={props.savedAddresses.firstSavedAddress} />}
               secondary="First saved address."
            />
         </ListItem> : null}
         <Divider variant="middle" component="li" />
         {props.savedAddresses.secondSavedAddress ? <ListItem
            secondaryAction={
               <IconButton edge="end" aria-label="delete" onClick={() => handleAddressDelete(2)}>
                  <DeleteIcon />
               </IconButton>
            }
         >
            <ListItemText
               primary={<AddressDisplay address={props.savedAddresses.secondSavedAddress} />}
               secondary="Second saved address."
            />
         </ListItem> : null}
         <Divider variant="middle" component="li" />
         {props.savedAddresses.thirdSavedAddress ? <ListItem
            secondaryAction={
               <IconButton edge="end" aria-label="delete" onClick={() => handleAddressDelete(3)}>
                  <DeleteIcon />
               </IconButton>
            }
         >
            <ListItemText
               primary={<AddressDisplay address={props.savedAddresses.thirdSavedAddress} />}
               secondary="Third saved address."
            />
         </ListItem> : null}
      </List>
   );
};

AddressListWidget.propTypes = {
   loading: PropTypes.bool.isRequired,
   savedAddresses: PropTypes.object.isRequired,
   onDeleteAddress: PropTypes.func.isRequired,
};

export default AddressListWidget;
